export default __webpack_public_path__ + "static/media/Int_TALANA.5789c18f.svg";